(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ContactAddress', ContactAddress);

    ContactAddress.$inject = ['$resource'];

    function ContactAddress ($resource) {
        var resourceUrl =  'api/contact-addresses/:id';

        return $resource(resourceUrl, {}, {
            'findAllByFacility': {
                url: 'api/contact-addresses/by-facility',
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT'},
            'faxeable': {url: 'api/contact-addresses/faxeable/:id', isArray: true}
        });
    }
})();
